import React, { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

import { AutoFocusPlugin } from '@lexical/react/LexicalAutoFocusPlugin';

export type Props = {
  scrollRef: {
    current?: HTMLElement | null;
  };
  shouldFocus?: boolean;
};

const FocusPlugin: React.FC<Props> = ({ scrollRef, shouldFocus }) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    editor.focus(
      () => {
        shouldFocus &&
          scrollRef.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
          });
      },
      { defaultSelection: 'rootEnd' },
    );
  }, [editor, scrollRef, shouldFocus]);

  return <AutoFocusPlugin defaultSelection="rootEnd" />;
};

export default FocusPlugin;
